var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"payments-reports-chart totals-chart",class:_vm.chartClass})}
var staticRenderFns = []

export { render, staticRenderFns }